// aiPatch.js
// Utility to fetch and apply AI code patches (diffs) for a given file

export async function fetchAIPatch({ code, language, model = 'gpt-4o', prompt }) {
  try {
    const res = await fetch('/api/ai/patch', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, language, model, prompt })
    });
    if (!res.ok) throw new Error('Failed to fetch patch');
    const data = await res.json();
    // Expecting data.patch as a unified diff or array of {line, newLine}
    return data.patch || '';
  } catch (e) {
    return '';
  }
}

// Apply a patch (array of {line, newLine}) to code, line by line
export function applyPatchToCode(original, patchArr) {
  let lines = original.split('\n');
  patchArr.forEach(({ line, newLine }) => {
    lines[line] = newLine;
  });
  return lines.join('\n');
}
